import * as React from "react";
import {
    List, Datagrid, TextField, EditButton, ShowButton, Edit, Create, Show,
    SimpleForm, SimpleShowLayout, TextInput, SelectInput, DateField, Filter,
    DeleteButton, NumberInput
} from 'react-admin';
import { UpLoadFile } from '../components/custom/UpLoadFile';

const DemandFilter = (props) => (
    <Filter {...props}>
        <TextInput label="搜索" source="key" alwaysOn />
        <SelectInput label="状态" source="Status" choices={[
            { id: 'pending', name: '待匹配' },
            { id: 'matching', name: '匹配中' },
            { id: 'in_progress', name: '进行中' },
            { id: 'completed', name: '已完成' },
            { id: 'cancelled', name: '已取消' },
        ]} />
        <SelectInput label="服务类型" source="ServiceType" choices={[
            { id: '农机', name: '农机' },
            { id: '植保', name: '植保' },
            { id: '飞防', name: '飞防' },
            { id: '托管', name: '托管' },
        ]} />
    </Filter>
);

export const AgriServiceDemandList = props => (
    <List {...props} filters={<DemandFilter />} title="服务需求管理">
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="ServiceType" label="服务类型" />
            <TextField source="Description" label="需求描述" />
            <TextField source="LandArea" label="面积(亩)" />
            <TextField source="CropType" label="作物" />
            <TextField source="ContactPerson" label="联系人" />
            <TextField source="ContactPhone" label="联系电话" />
            <TextField source="Status" label="状态" />
            <TextField source="Budget" label="预算(元)" />
            <DateField source="ExpectedDate" label="期望日期" />
            <DateField source="CreateTime" label="发布时间" showTime />
            <EditButton />
            <ShowButton />
            <DeleteButton />
        </Datagrid>
    </List>
);

export const AgriServiceDemandShow = props => (
    <Show {...props} title="需求详情">
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="ServiceType" label="服务类型" />
            <TextField source="Description" label="需求描述" />
            <TextField source="LandArea" label="面积(亩)" />
            <TextField source="CropType" label="作物" />
            <TextField source="Location" label="地块位置" />
            <TextField source="ContactPerson" label="联系人" />
            <TextField source="ContactPhone" label="联系电话" />
            <TextField source="Budget" label="预算(元)" />
            <TextField source="Status" label="状态" />
            <TextField source="AssignedProviderId" label="选定主体ID" />
            <TextField source="AcceptedBidId" label="选定报价ID" />
            <DateField source="ExpectedDate" label="期望日期" />
            <DateField source="CreateTime" label="发布时间" showTime />
        </SimpleShowLayout>
    </Show>
);

export const AgriServiceDemandEdit = props => (
    <Edit {...props} title="编辑需求">
        <SimpleForm>
            <TextInput disabled source="id" />
            <SelectInput source="ServiceType" label="服务类型" choices={[
                { id: '农机', name: '农机' },
                { id: '植保', name: '植保' },
                { id: '飞防', name: '飞防' },
                { id: '托管', name: '托管' },
            ]} />
            <TextInput source="Description" label="需求描述" multiline />
            <NumberInput source="LandArea" label="面积(亩)" />
            <TextInput source="CropType" label="作物" />
            <TextInput source="Location" label="地块位置" />
            <TextInput source="ContactPerson" label="联系人" />
            <TextInput source="ContactPhone" label="联系电话" />
            <NumberInput source="Budget" label="预算(元)" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 'pending', name: '待匹配' },
                { id: 'matching', name: '匹配中' },
                { id: 'in_progress', name: '进行中' },
                { id: 'completed', name: '已完成' },
                { id: 'cancelled', name: '已取消' },
            ]} />
        </SimpleForm>
    </Edit>
);

export const AgriServiceDemandCreate = props => (
    <Create {...props} title="新建需求">
        <SimpleForm>
            <SelectInput source="ServiceType" label="服务类型" choices={[
                { id: '农机', name: '农机' },
                { id: '植保', name: '植保' },
                { id: '飞防', name: '飞防' },
                { id: '托管', name: '托管' },
            ]} />
            <TextInput source="Description" label="需求描述" multiline />
            <NumberInput source="LandArea" label="面积(亩)" />
            <TextInput source="CropType" label="作物" />
            <TextInput source="Location" label="地块位置" />
            <TextInput source="ContactPerson" label="联系人" />
            <TextInput source="ContactPhone" label="联系电话" />
            <NumberInput source="Budget" label="预算(元)" />
        </SimpleForm>
    </Create>
);
